import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Translation } from "react-i18next";

import {
    Button,
    Input,
    InputGroupAddon,
    InputGroup,
    UncontrolledTooltip
} from "reactstrap";

import { updateComponent,updateList } from '_actions';
import { findObjUpdate } from 'assets/util';

class PaddingProperty extends Component {

    constructor(props) {
        super(props)
        const { component } = props;
        const { object } = component.hasOwnProperty("componentOwner") ? component.object.components[0] : component.components[0];
        const { style, value } = object.props;

        this.state = {
            isAll: true,
            paddingTop: component && parseInt(style["paddingTop"] == undefined ? "0px" : style["paddingTop"]),
            paddingBottom: component && parseInt(style["paddingBottom"] == undefined ? "0px" : style["paddingBottom"]),
            paddingRight: component && parseInt(style["paddingRight"] == undefined ? "0px" : style["paddingRight"]),
            paddingLeft: component && parseInt(style["paddingLeft"] == undefined ? "0px" : style["paddingLeft"]),
        }

    }

    checkIsEqual = () => {
        const { paddingTop, paddingBottom, paddingRight, paddingLeft } = this.state;
        if (paddingTop == paddingBottom == paddingRight == paddingLeft) {
            return true;
        } else {
            return false;
        }
    }


    setProperties = () => {
        let _clone = Object.assign({}, this.props.component);

        const that = this;

        if (_clone.hasOwnProperty("componentOwner")) {
            _clone.object.components[0].object.props.style = {
                ..._clone.object.components[0].object.props.style,
                paddingTop: that.state.paddingTop + "px",
                paddingBottom: that.state.paddingBottom + "px",
                paddingRight: that.state.paddingRight + "px",
                paddingLeft: that.state.paddingLeft + "px",
            }
        } else {
            _clone.components[0].object.props.style = {
                ..._clone.components[0].object.props.style,
                paddingTop: that.state.paddingTop + "px",
                paddingBottom: that.state.paddingBottom + "px",
                paddingRight: that.state.paddingRight + "px",
                paddingLeft: that.state.paddingLeft + "px",
            }
        }

        let _newEditor = JSON.parse(JSON.stringify(this.props.editor))
        let _result = findObjUpdate(_newEditor, _clone);
        this.props.updateComponent(_clone);
        this.props.onUpdateList(_result);
    }


    handleChange = (event) => {
        const { target } = event;
        const { name } = target;
        let value = (event.target.validity.valid) ? event.target.value : (this.state.isAll ? this.state.paddingTop : this.state[name]);
        const that = this;

        if (value.length < 1) { value = "0" }

        value = parseInt(value);

        if (this.state.isAll) {
            this.setState({
                paddingTop: value,
                paddingBottom: value,
                paddingRight: value,
                paddingLeft: value,
            }, () => {
                that.setProperties();
            });
        } else {
            this.setState({
                [name]: value,
            }, () => {
                that.setProperties();
            });
        }


    }

    componentDidMount() {
        this.setState({
            isAll: this.checkIsEqual(),
        })
    }
    componentDidUpdate = (prevProps) => {
        const { component } = this.props;
        const { object } = component.hasOwnProperty("componentOwner") ? component.object.components[0] : component.components[0];
        const { style, value } = object.props;

        if (prevProps.component != component) {
            this.setState({
                //isAll: this.checkIsEqual(),
                paddingTop: parseInt(style["paddingTop"] == undefined ? "0px" : style["paddingTop"]),
                paddingBottom: parseInt(style["paddingBottom"] == undefined ? "0px" : style["paddingBottom"]),
                paddingRight: parseInt(style["paddingRight"] == undefined ? "0px" : style["paddingRight"]),
                paddingLeft: parseInt(style["paddingLeft"] == undefined ? "0px" : style["paddingLeft"]),
            })
        }
    }
    handleChangeType = () => {
        this.setState({
            isAll: !this.state.isAll,
            paddingTop: !this.state.isAll ? this.state.paddingTop : this.state.paddingTop,
            paddingBottom: !this.state.isAll ? this.state.paddingTop : this.state.paddingBottom,
            paddingRight: !this.state.isAll ? this.state.paddingTop : this.state.paddingRight,
            paddingLeft: !this.state.isAll ? this.state.paddingTop : this.state.paddingLeft,
        }, () => {
            this.setProperties();
        })
    }

    onKeyDown = (event) => {
        if (event.key === 'Enter') { event.preventDefault() }
    }



    render() {
        const { component } = this.props;
        const { isAll } = this.state;
        return (
            <Translation>
                {t => (
                    <div>

                        <InputGroup className="mb-3">
                            <InputGroupAddon addonType="prepend">
                                <Button onClick={this.handleChangeType} size="sm" color="primary" outline={!isAll} type="button">
                                    <i className="far fa-square"></i>
                                </Button>
                                <Button onClick={this.handleChangeType} size="sm" color="primary" outline={isAll} type="button">
                                    <i className="fas fa-expand"></i>
                                </Button>
                            </InputGroupAddon>
                            {
                                isAll ? (
                                    <Input
                                        pattern="[0-9]*"
                                        name={"paddingLeft"}
                                        value={this.state.paddingLeft}
                                        onBlur={() => { }}
                                        onKeyDown={this.onKeyDown.bind(this)}
                                        onInput={this.handleChange.bind(this)}
                                        onChange={() => { }}
                                        className="form-control-sm"
                                        placeholder="" type="text" />
                                ) : (
                                        <>
                                            <Input
                                                pattern="[0-9]*"
                                                id={"padding-left-weigth"}
                                                name={"paddingLeft"}
                                                value={this.state.paddingLeft}
                                                onKeyDown={this.onKeyDown.bind(this)}
                                                onBlur={() => { }}
                                                onChange={(e) => {
                                                    this.handleChange(e)
                                                }}
                                                className="form-control-sm"
                                                placeholder="" type="text" />
                                            <UncontrolledTooltip
                                                delay={0}
                                                placement="top"
                                                target="padding-left-weigth">
                                                {t("PROPERTY_LAYOUT_PADDING_LEFT")}
                                            </UncontrolledTooltip>
                                            <Input
                                                pattern="[0-9]*"
                                                id={"padding-right-weigth"}
                                                name={"paddingRight"}
                                                value={this.state.paddingRight}
                                                onKeyDown={this.onKeyDown.bind(this)}
                                                onBlur={() => { }}
                                                onChange={(e) => {
                                                    this.handleChange(e)
                                                }}
                                                className="form-control-sm"
                                                placeholder="" type="text" />
                                            <UncontrolledTooltip
                                                delay={0}
                                                placement="top"
                                                target="padding-right-weigth">
                                                {t("PROPERTY_LAYOUT_PADDING_RIGHT")}
                                            </UncontrolledTooltip>
                                            <Input
                                                pattern="[0-9]*"
                                                id={"padding-top-weigth"}
                                                name={"paddingTop"}
                                                value={this.state.paddingTop}
                                                onKeyDown={this.onKeyDown.bind(this)}
                                                onBlur={() => { }}
                                                onChange={(e) => {
                                                    this.handleChange(e)
                                                }}
                                                className="form-control-sm"
                                                placeholder="" type="text" />
                                            <UncontrolledTooltip
                                                delay={0}
                                                placement="top"
                                                target="padding-top-weigth">
                                                {t("PROPERTY_LAYOUT_PADDING_TOP")}
                                            </UncontrolledTooltip>
                                            <Input
                                                pattern="[0-9]*"
                                                id={"padding-bottom-weigth"}
                                                name={"paddingBottom"}
                                                value={this.state.paddingBottom}
                                                onKeyDown={this.onKeyDown.bind(this)}
                                                onBlur={() => { }}
                                                onChange={(e) => {
                                                    this.handleChange(e)
                                                }}
                                                className="form-control-sm"
                                                placeholder="" type="text" />
                                            <UncontrolledTooltip
                                                delay={3}
                                                placement="top"
                                                target="padding-bottom-weigth">
                                                {t("PROPERTY_LAYOUT_PADDING_BOTTOM")}
                                            </UncontrolledTooltip>
                                        </>
                                    )
                            }



                        </InputGroup>

                    </div>

                )}
            </Translation>
        )
    }
}

//export default InputGenerator
const mapStateToProps = (state) => {
    const { componentReducer,editorReducer } = state;
    const { component } = componentReducer;
    const { present } = editorReducer;
    const { editor } = present;

    return {
        component,
        editor
    };
}
const mapDispatchToProps = {
    onUpdateList: updateList,
    updateComponent,
}
export default connect(mapStateToProps, mapDispatchToProps)(PaddingProperty)
